import * as React from "react";
import {Link} from "react-router-dom";
import {PROCESS_PAY_OFF_BALANCE, productHelper} from "@falcon/services";

interface IProps {
    interaction: any;
    policyNumber: string;
    payOffAmountWithRemainingInterest?: number;
    remainingInterest?: number;
}

export class AccountBalanceSection extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }


    public render() {
        const remainingAmountPresent: boolean = Math.abs(this.props.payOffAmountWithRemainingInterest!) !== 0;
        const isHome: boolean = productHelper.isHome(this.props.interaction);
        const productWording: string = isHome ? "home" : "car";
        const product: any = this.props.interaction.product;
        const payOffUrl: string = this.props.interaction?.paymentDetails?.paymentType === "directDebit" ? `/dashboard/${this.props.policyNumber}/payOffBalance`  : `/journey/init/product/${product}/process/mtaPayOffBalance/presetPage/${this.props.interaction?._id}`;
        const disableButton: boolean =  window.sessionStorage.getItem("referrerJourney") === PROCESS_PAY_OFF_BALANCE;

        return (
            <div className="text-center my-4 payment-details-section grid-col-1-2 icon-money-exchange-before">
                <div className="dashboard-panel-title my-3">Account balance</div>
                <div className="justify-content-center mt-2 grid-col-2">
                    <div>
                        <span id="account-balance" className="font-weight-semi-bold my-3 grid-col-2">-£{Math.abs(this.props.payOffAmountWithRemainingInterest!)}</span>
                        <span> (incl. Interest and Insurance Premium Tax)</span>
                        {remainingAmountPresent && <p className="mb-5 mt-2">By paying off your {productWording} insurance, you're saving
                            £{this.props.remainingInterest} in interest charges. There are no fees on
                            doing this.</p>}
                    </div>
                    {
                        <Link
                            to={remainingAmountPresent ? payOffUrl : `#`} /* TODO: WTF is that empty link */
                            id="payOffBalance"
                            className={disableButton ? "btn btn-disabled-dashboard m-auto" : "btn btn-white-dashboard m-auto"}>
                            Pay off my balance
                        </Link>
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/paymentDetails/annual/AccountBalanceSection.tsx